import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { ContractLotRoutingModule } from "./contract-lot-moha-routing.module";
import { MaterialModule } from "src/app/core/material";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "src/app/shared/shared.module";
import { TranslateModule } from "@ngx-translate/core";
import { MatAutocompleteModule, MatInputModule, MatProgressBarModule } from "@angular/material";
import { NgMatAutocompleteModule } from "src/app/shared/components/autocomplete/autocomplete.module";
import { NgxMaskModule } from "ngx-mask";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { NgZorroAntdModule } from "ng-zorro-antd";
import { SlickCarouselModule } from "ngx-slick-carousel";
import { NotifyModule } from "../notify/notify.module";
import { HotTableModule } from "@handsontable/angular";
import { AddLotMohaComponent } from "./add-lot-moha/add-lot-moha.component";
import { SignatureConfigLotMohaComponent } from './signature-config-lot-moha/signature-config-lot-moha.component';
import { ConfigSigningFlowMohaComponent } from './config-signing-flow-moha/config-signing-flow-moha.component';
import { WarningDialogMohaComponent } from './warning-dialog-moha/warning-dialog-moha.component';

@NgModule({
  declarations: [
    AddLotMohaComponent,
    SignatureConfigLotMohaComponent,
    ConfigSigningFlowMohaComponent,
    WarningDialogMohaComponent
  ],
  imports: [
    CommonModule,
    ContractLotRoutingModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    NgMatAutocompleteModule,
    MatInputModule,
    NgxMaskModule.forChild(),
    NgxExtendedPdfViewerModule,
    NgZorroAntdModule,
    SlickCarouselModule,
    NotifyModule,
    HotTableModule,
  ],
  exports: [],
  entryComponents: [
    WarningDialogMohaComponent,
    AddLotMohaComponent,
  ],
})
export class ContractLotMohaModule {}
